import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()({
  container: {
    padding: '5px',
    height: 'calc(100dvh - 56px)',
    overflow: 'auto',
  },
})
